import AbstractApiService from 'src/services/abstractApiService';
import { api } from 'pages/APIs';

export default class AIModelsAndLabelsApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async getModels(): Promise<any> {
    return super.get(api.custom_model_list);
  }

  public async getModelLabels(model_name: string): Promise<any> {
    const querystring = this.encodeQueryData({
      model_name: model_name,
    });
    return super.get(api.custom_model_label + '?' + querystring, {});
  }

  public async updateModel(data: any): Promise<any> {
    const id = data.id;
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }

    return super.put(api.custom_model_update + '/' + id, formData);
  }

  public async updateLabel(data: any): Promise<any> {
    const id = data.id;
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }

    return super.put(api.custom_model_label_update + '/' + id, formData);
  }

  public async getNextModelTrainingTime(): Promise<any> {
    return super.get(api.get_next_model_training_schedule, {});
  }
}
